export default "__VITE_ASSET__c10106ca__"